<div class="card">
    <div class="card-body">
        <div class="container">
            <div class="roles row mb-5">
                <div class="mr-3" langSection="Users" langKey="Role_Column" style="font-size: 18px;">{{getLocalizedUsersString("Role_SubTitle", "Role: ", selectedUser.ProfileName)}} </div>
                <a href="/Admin/ProfileAdmin.aspx" class="manageRoles text-primary p-0 mr-auto d-flex align-items-center justify-content-center" langSection="Users" langKey="Manage_Roles" *ngIf="!editMode" style="font-size: 14px;">{{getLocalizedUsersString("Manage_Roles", "Manage Roles")}}</a>
                <div *ngIf="!editMode && !viewOnly">
                    <svg class="icon-16 fill-cerulean float-right mt-1 pencilIcon" style="align-items: flex-end;" (click)="editChange()"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
                </div>
                <div *ngIf="viewOnly">
                    {{getLocalizedUsersString('View_Only', 'View Only')}}
                </div>
            </div>
            <div class="navigation row mb-3" *ngIf="hasWidgets || hasPages">
                <div class="col-4 row pl-3 d-flex align-items-center">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{'active': tab === 'tab1'}" (click)="pagesTabClicked()">{{getLocalizedUsersString("Pages", "Pages")}}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{'active': tab === 'tab2'}" (click)="widgetsTabClicked()">{{getLocalizedUsersString("Widgets", "Widgets")}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-8 p-0" style="margin-left: 30px;">
                    <div class="search-box live-search float-right" style="width: 65%;">
                        <input type="search" class="form-control form-control-lg" id="searchBox" autocomplete="off" [placeholder]="getLocalizedUsersString('Search', 'Search')" [(ngModel)]="search"
                            (ngModelChangeDebounced)="applyFilter()" [ngModelChangeDebounceTime]="400"
                            style="border-radius: 4px;"/>
                        <span class="clear-input" [hidden]="search.length === 0" (click)="clearFilter()"></span>
                    </div>
                </div>
            </div>
            <div class="ag-grid row mb-5" id="Pages" *ngIf="tab === 'tab1'">
                <div class="pageList w-100">
                    <ag-grid-angular #accessUserAdminAccessGrid *ngIf="accessGridOptions != null && hasPages" class="ag-theme-balham ag-basic w-100 h-100" [gridOptions]="accessGridOptions" (gridReady)="onGridReady($event)"></ag-grid-angular>
                    <div *ngIf="!hasPages">
                        <cv-loader size="medium"></cv-loader>
                    </div>
                </div>
            </div>
            <div class="ag-grid row mb-5" id="Widgets" *ngIf="tab === 'tab2'">
                <div class="pageList w-100">
                    <ag-grid-angular #accessUserAdminWidgetsGrid *ngIf="widgetsGridOptions != null && hasWidgets" class="ag-theme-balham ag-basic w-100 h-100" [gridOptions]="widgetsGridOptions" (gridReady)="onGridReady($event)"></ag-grid-angular>
                    <div *ngIf="!hasWidgets">
                        <cv-loader size="medium"></cv-loader>
                    </div>
                </div>
            </div>
            <div class="editButtons row" *ngIf="editMode">
                <div class="col p-0">
                    <button type="button" class="btn btn-primary float-right" (click)="saveChanges()" langSection="Users" langKey="Save_Changes" [disabled]="disableSaveButton">{{getLocalizedUsersString("Save_Changes", "Save Changes")}}</button>
                    <button type="button" class="btn btn-text float-right mr-2" (click)="cancelButtonClick()" langSection="Users" langKey="Cancel">{{getLocalizedUsersString("Cancel", "Cancel")}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
